// import { IServiceLocation } from "../user/types";

import { PaymentGateway, PaymentMode } from "../bookings/types";

export interface IConsumerWebsiteState {
  consumerWebsite: IConsumerWebsite;
}

export type WebsitePayloadType = IConsumerWebsite | IConsumerWebsiteId;

export interface IConsumerWebsiteId {
  id?: string;
}
export interface IConsumerWebsite {
  id?: string;
  clientId?: string;
  appName: string;
  domain: string;
  websiteTitle: string;
  websiteIcon: string;
  websiteLogo: string;
  websiteHeader: string;
  hasCarousel: boolean;
  hasGallery: boolean;
  hasFeaturedOffers?: boolean;
  featuredOffers?: IFeaturedOffer[];
  enableUserDropoffTrackingWebsite?: boolean;
  branding: IBranding;
  organisationId: string;
  tenantId: string;
  branchIds: string[];
  bookingQuestions: IBookingQuestion[];
  websiteDescription: string;
  carousel: string[];
  gallery: string[];
  privacyPolicyURL: string;
  termsAndConditionsURL: string;
  branches: IBranch[];
  organisation: IOrganisation;
  tenancy: ITenancy;
  logoSize: number;
  htmlDescription: boolean;
  companyWebsite?: string;
  googleGTMId?: string;
  allowedRateTypes?: string[];
  allowedBillingFrequencies?: string[];
  enableBusinessCustomerSignup: boolean;
  vatInclusivePricingEnabled?: boolean;
  paymentGateway?: PaymentGateway;
  bookingTypes: string[];
  subscriptionSettings: ISubscriptionSettings;
  hideInsurance?: boolean;
  pcoRentalOnly?: boolean;
  multipleVehicleBooking?: boolean;
  disableSelfRegistration?: boolean;
  vehicleDetailsSettings?: IVehicleDetailsSettings;
  isMultiOrganisation?: boolean;
  hideFilters?: boolean;
  enableBookingEnquiry?: boolean;
  minLeadTimeOptIn?: boolean;
  minLeadTimeValue?: number;
  minLeadTimeUnit?: string;
  maxLeadTimeOptIn?: boolean;
  maxLeadTimeValue?: number;
  maxLeadTimeUnit?: string;
}

export interface IFeaturedOffer {
  offerId: string;
  imageUrl?: string;
}

export interface IVehicleDetailsSettings {
  showVehicleOnGroup: boolean;
  showAddons: boolean;
  categories: IVehicleDetailsSettingsCategory;
}

export interface IVehicleDetailsSettingsCategory {
  specification: IVehicleDetailsSettingsCategoryDetails;
  interiorFeatures: IVehicleDetailsSettingsCategoryField;
  exteriorFeatures: IVehicleDetailsSettingsCategoryField;
  safetyAndTech: IVehicleDetailsSettingsCategoryField;
  otherFeatures: IVehicleDetailsSettingsCategoryField;
}

export interface IVehicleDetailsSettingsCategoryDetails {
  enabled: boolean;
  fields: IVehicleDetailsSettingsCategoryFieldSpecification;
}

export interface IVehicleDetailsSettingsCategoryFieldSpecification {
  numberOfDoors: boolean;
  numberOfSeats: boolean;
  transmission: boolean;
  color: boolean;
  fuelType: boolean;
}

export interface IVehicleDetailsSettingsCategoryField {
  enabled: boolean;
}
export interface IAppSetting {
  id?: string;
  appName: string;
  organisationId: string;
  branchIds: string[];
  privacyPolicyURL: string;
  provider?: string;
  callbackUris?: string;
  clientId?: string;
  clientSecret?: string;
  firstParty?: boolean;
  companyWebsite: string;
  termsAndConditionsURL: string;
  branding: IBranding;
  isActive: boolean;
  hideFilters?: boolean;
  webAppSetting: IWebSetting;
  organisation?: Partial<IOrganisation>;
  tenancy?: Partial<ITenancy>;
  tenantId: string;
  mobileAppSetting: IMobileAppSetting;
  paymentGateway?: PaymentGateway;
  hideInsurance?: boolean;
  isMultiOrganisation?: boolean;
  enableBookingEnquiry?: boolean;
}

export interface IWebSetting {
  websiteTitle: string;
  websiteIcon: string;
  websiteLogo: string;
  domain: string;
  websiteHeader: string;
  websiteDescription: string;
  websiteAddress: string;
  logoSize: number;
  htmlDescription: boolean;
  hasCarousel: boolean;
  carousel: string[];
  hasGallery: boolean;
  gallery: string[];
  googleGTMId: string;
  enableBusinessCustomerSignup: boolean;
  vatInclusivePricingEnabled?: boolean;
}

export interface ITermsAndConditions {
  rentalUrl: string
  subscriptionUrl: string
  testDriveUrl: string
}

export interface IMobileAppSetting {
  appIcon: string;
  companyIcon: string;
  straplineIcon: string;
  landingPageIcon: string;
}

export interface IBranding {
  buttonColor: string;
  accentColor: string;
}

export type TBQAnswer = string | boolean;
export interface IBookingQuestion {
  question: string;
  answerType: ANSWER_TYPES;
  required: boolean;
  deleted?: boolean;
  answer?: TBQAnswer;
  expectedAnswer?: string;
  options?: string[];
  errorMessage?: string;
  B2B?: boolean;
  B2B2C?: boolean;
}
export enum ANSWER_TYPES {
  YES_NO = "YES_NO",
  DROP_DOWN = "DROP_DOWN",
  TEXT = "TEXT",
  CHECKBOX = "CHECKBOX",
}
export interface IB2b2cSettings {
  active: boolean;
  carousels: string[];
  vehicles: string[];
  description: string;
  privacyPolicyURL: string;
  websiteTitle: string;
  favicon: string;
}
export interface IOrganisation {
  id: string;
  address: IAddress;
  locale: string;
  owner: string;
  emailId: string;
  name: string;
  phoneNumber: IPhoneNumberInput;
  termsAndConditions: ITermsAndConditions;
  currency: string;
  logoUrl: any;
  rate: any;
  stripeAccountId?: string;
  globalPaymentCredentials?: IGlobalPaymentCredentials;
  orgVatNumber: string;
  orgRegNumber: string;
  taxes: ITax[];
  branches: IBranch[];
  autoRateType?: boolean;
  requiresCustomerVerification: boolean;
  requiresLoginForBooking?: boolean;
  allowSubscriptionBookings?: boolean;
  discountModuleEnabled?: boolean;
  allowCarSharing?: boolean;
  autoChargeEnabled?: boolean;
  closeGroupSharingEnabled?: boolean;
  serviceRequestEnabled?: boolean;
  enableCostCenter?: boolean;
  crossLocationBookingEnabled?: boolean;
  costCenters?: ICostCenter[];
  maxImagesPerDamage?: number;
  convergeEnabled?: boolean;
  extendedTestDriveMaxHours?: number;
  standardTestDriveDuration?: IStandardTestDriveDuration;
  enableExtendedTestDrive?: boolean;
  supplierPortalEnabled: boolean;
  enableProtectionPlanForPCO?: boolean;
  bookingCategories: IBookingCategory[];
  allowContactlessBookings?: boolean;
  fleetAllocationEnabled?: boolean;
  enableProjectIds?: boolean;
  hideYearFilter?: boolean;
  enablePaymentProcessingFee?: boolean;
  paymentProcessingFee?: IProcessingFee[];
  enableBookingCreationForApprovedDriver?: boolean;
}

export enum ProcessingFeeType {
  FIXED = "FIXED",
  PERCENTAGE = "PERCENTAGE"
}

export interface IProcessingFeeDetails {
  paymentGateway: PaymentGateway;
  feeType: ProcessingFeeType;
  value: number;
}

export type IProcessingFee = {
  paymentMode: PaymentMode;
  gateways: IProcessingFeeDetails[];
}

export interface IGlobalPaymentCredentials {
  gpAppId: string;
  gpAppKey: string;
}
export interface IStandardTestDriveDuration {
  active: boolean;
  hour: number;
}

export interface IBookingCategory {
  isActive: boolean;
  type: BOOKING_CATEGORY;
  default: boolean;
  isDriverAllocationRuleEnabled?: boolean;
  isContractHire?: boolean;
}

export enum BOOKING_CATEGORY {
  RENTAL = "RENTAL",
  SUBSCRIPTION = "SUBSCRIPTION",
  TEST_DRIVE = "TEST_DRIVE",
  COURTESY_CAR = "COURTESY_CAR"
}

export interface ICostCenter {
  name: string;
  projectIds: string[];
}
export interface IPhoneNumberInput {
  phone: string;
  country: string;
}
export interface ITenancy {
  id?: string;
  owner?: IOwner;
  chargebeeAddons?: string[];
  loginEnabled?: boolean;
  logisticsEnabled?: boolean;
  identityVerification?: {
    provider: string;
    enabled: boolean;
    id: string;
  };
}

export interface IOwner {
  id: string;
  userPoolId: string;
  identityPoolId: string;
}

export interface IBilling {
  name: string;
  billingAddressSame: boolean;
  address: IAddress;
  emailId: string;
  phoneNumber: IPhoneNumberInput;
}

export interface IOrganisationId {
  id: string;
}

export interface IBranch {
  id: string;
  address: IAddress;
  owner: string;
  emailId: string;
  timeZone: string;
  name: string;
  phoneNumber: IPhoneNumberInput;
  locations: IServiceLocation[];
  activeLocations: IServiceLocation[];
  operatingHours: IOperatingHours[];
  minBookingDuration?: number;
  maxBookingDuration?: number;
  minimumBookingAmount?: IMinimumBookingAmount;
  depositCollection?: string;
  minBookingAmountOptIn: boolean;
  minBookingDurationOptIn?: boolean;
  maxBookingDurationOptIn?: boolean;
  overbookingAllowed: boolean;
  preBookingQuestions: IBookingQuestion[];
  distanceUnit: string;
  holidays: IHoliday[];
  addTaxOptIn: boolean;
  taxes: ITax[];
  vehiclePreparationTime: number;
  enableQuoteInfo?: boolean;
  quoteInfo?: string;
  enableBookingQuestions?: boolean;
  riskBasedPricingEnabled?: boolean;
}

export interface IHoliday {
  id?: string;
  name: string;
  startDate: string;
  endDate: string;
  isActive: boolean;
  allowDropOffs: boolean;
}

export interface IMinimumBookingAmount {
  type: string;
  value: number;
}
export interface IOperatingHours {
  day: string;
  dayIndex: number;
  pickupFromTime?: string;
  pickupToTime?: string;
  returnFromTime?: string;
  returnToTime?: string;
  closed: boolean;
  allowDropOffs: boolean;
}

export interface IBranchId {
  id: string;
}

export interface IServiceLocation {
  id: string;
  address: IAddress;
  name: string;
  branch?: string | Partial<IBranch>;
}

export interface IServiceLocationId {
  id: string;
}

export interface ITax {
  id: string;
  title: string;
  rate: string;
  type: string;
  value: number;
  isVehicleGroupSpecific?: boolean;
  vehicleGroups?: string[];
  subdivisionOptIn: boolean;
  subdivisionType: string;
  subdivisionRate: string;
  subdivisionValue: number;
}

export interface IAddress {
  street?: string;
  city?: string;
  state?: string;
  country: string;
  zipcode?: string;
  fullAddress?: string;
  geometry?: IGeometry;
}

export interface IGeometry {
  type: string;
  latitude: number;
  longitude: number;
}

export interface ISubscriptionSettings {
  dvlaVerificationEnabled: boolean;
  creditCheckEnabled: boolean;
  idvEnabled: boolean;
};

export enum FLOW {
  BOOKING = "BOOKING",
  FLEET_ALLOCATION = "FLEET_ALLOCATION"
}

export enum IdentityVerificationStatus {
  PENDING = "PENDING",
  APPROVED = "APPROVED",
  REJECTED = "REJECTED",
  // NU-12935: Entrust's workflow_run.completed webhook can report a terminal
  // "review" outcome (routed to manual review) - distinct from a settled
  // APPROVED/REJECTED. Without this, polling never saw a terminal status for
  // a review outcome and looped forever.
  IN_REVIEW = "IN_REVIEW"
}